import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import Configuration from "../configuration";
var token = localStorage.getItem("x-access-token");

export const fetchSimulationC = createAsyncThunk("simulationC/fetchSimulationC", async (action) => {
  const response = await fetch(Configuration.BACK_BASEURL + "simulationC/allSimulationC", {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-access-token': token
    },

    body: JSON.stringify(action)
  });
  const simulationC = await response.json();
  return simulationC;
});

export const fetchSimulationCGro = createAsyncThunk("simulationC/fetchSimulationCGro", async (action) => {
  const response = await fetch(Configuration.BACK_BASEURL + "simulationC/allSimulationCGro", {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-access-token': token
    },

    body: JSON.stringify(action)
  });
  const simulationC = await response.json();
  return simulationC;
});

export const fetchSimulationCOnly = createAsyncThunk("simulationC/allhissimulationC", async (action) => {
  console.log(action)
  const response = await fetch(Configuration.BACK_BASEURL + "simulationC/allhissimulationC", {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-access-token': token
    },
    body: JSON.stringify(action)
  });
  const simulationC = await response.json();
  return simulationC;
});

export const fetchSimulationCGroOnly = createAsyncThunk("simulationC/fetchSimulationCGroOnly", async (action) => {
  console.log(action)
  const response = await fetch(Configuration.BACK_BASEURL + "simulationC/fetchSimulationCGroOnly", {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-access-token': token
    },
    body: JSON.stringify(action)
  });
  const simulationC = await response.json();
  return simulationC;
});

export const simulationCDeleted = createAsyncThunk("simulationC/delete", async (action) => {
  const response = await fetch(Configuration.BACK_BASEURL + "simulationC/delete/" + action.id, {
    method: 'DELETE',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-access-token': token
    },
  });
  const simulationC = await response.json();
  return simulationC;
});

export const marcheLigneGetById = createAsyncThunk("simulationC/marcheLigneGetById", async (id1) => {
  const id = id1;
  const response = await fetch(Configuration.BACK_BASEURL + "simulationC/marcheLigneGetById", {
    method: 'POST',
    headers: {
      'id': id,
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-access-token': token
    },

  });
  const simulationC = await response.json();
  return simulationC;
});

export const getActiveMarche = createAsyncThunk("simulationC/getActiveMarche", async () => {
  const response = await fetch(Configuration.BACK_BASEURL + "simulationC/getActive", {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-access-token': token
    },

  });
  const simulationC = await response.json();
  return simulationC;
});


export const simulationCGetById = createAsyncThunk("simulationC/simulationCGetById", async (id1) => {
  const id = id1;
  const response = await fetch(Configuration.BACK_BASEURL + "simulationC/getSimulationC", {
    method: 'POST',
    headers: {
      'id': id,
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-access-token': token
    },

  });
  const simulationC = await response.json();
  return simulationC;
});

export const simulationCAdded = createAsyncThunk("simulationC/addSimulationC", async (action) => {
  const response = await fetch(Configuration.BACK_BASEURL + "simulationC/addSimulationC", {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-access-token': token
    },
    body: JSON.stringify(action)
  });
  const simulationC = await response.json();
  return simulationC;
});

export const simulationCUpdated = createAsyncThunk("simulationC/simulationCUpdated", async (action) => {
  const response = await fetch(Configuration.BACK_BASEURL + "simulationC/simulationCUpdated", {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-access-token': token
    },
    body: JSON.stringify(action)
  });
  const simulationC = await response.json();
  return simulationC;
});

export const simulationCGroAdded = createAsyncThunk("simulationC/simulationCGroAdded", async (action) => {
  const response = await fetch(Configuration.BACK_BASEURL + "simulationC/simulationCGroAdded", {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-access-token': token
    },
    body: JSON.stringify(action)
  });
  const simulationC = await response.json();
  return simulationC;
});

const simulationCReduce = createSlice({
  name: "simulationC",
  initialState: {
    entities: [],
    loading: false,
  },
  reducers: {
    /* simulationCAdded(state, action) {
      fetch(Configuration.BACK_BASEURL + "simulationC/addSimulationC", {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'x-access-token':token
        },
        body: JSON.stringify(action.payload)
      });
    }, */

  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchSimulationC.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(fetchSimulationC.fulfilled, (state, action) => {
        state.loading = false;
        state.entities = [...state.entities, ...action.payload];
      })
      .addCase(fetchSimulationC.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(simulationCGetById.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(simulationCGetById.fulfilled, (state, action) => {
        state.loading = false;
        state.entities = [...state.entities, action.payload];
      })
      .addCase(simulationCGetById.rejected, (state, action) => {
        state.loading = false;
      });
  },

});

/* export const { simulationCAdded } = simulationCReduce.actions; */

export default simulationCReduce.reducer;
